import React from 'react'
import './style.css'

const DownloadButtons = () => {
    return (
        <>
            <div className="download-buttons">
                <a href="#" className='play-store-button'>
                    <div className="donwload-button">
                        <i className="fa-brands fa-google-play"></i>
                        <div className="download-button-text">
                            <p>GET IT ON</p>
                            <h3>Google Play</h3>
                        </div>
                    </div>
                </a>

                <a href="#">
                    <div className="donwload-button">
                        <i className="fa-brands fa-apple apple-icon"></i>
                        <div className="download-button-text">
                            <p>Download on the</p>
                            <h3>App Store</h3>
                        </div>
                    </div>
                </a>
            </div>
        </>
    )
}

export default DownloadButtons